<app-loading class="app-loading" *ngIf="loading"></app-loading>
<div *ngIf="!loading">
  <div class="header-large-device">
    <div class="toolbar-container sticky-bar">
      <div class="toolbar-top-section">
        <div style="width: 29%">
          <a [href]="vHostUrl">
            <img class="primary-logo" [src]="data.primaryLogoLink" alt="primary-logo" />
          </a>
        </div>
        <div style="width: 40%" fxLayout="column">
          <div class="header-search-bar" fxLayout="row">
            <input
              style="border-radius: 2rem 0 0 2rem"
              [(ngModel)]="searchInput"
              (keyup.enter)="onSearch()"
              (keyup)="onKeyUpSearchClear($event.target.value)"
              matInput
              type="text"
              placeholder="Search for products" />
            <button
              class="close-btn"
              *ngIf="searchInput.length"
              (click)="onSearchClear()"
              mat-icon
              button
              matSuffix>
              <mat-icon>close</mat-icon>
            </button>
            <button
              style="border-radius: 0 2rem 2rem 0; margin: 0px 0px 0px 0px"
              mat-button
              id="product-search"
              aria-labelledby="product-search-label"
              class="search-btn"
              (click)="onSearch()">
              <mat-icon aria-hidden="true">search</mat-icon>
              <span id="product-search-label" class="sr-only">Search</span>
            </button>
          </div>
        </div>
        <div style="width: 29%" fxLayoutGap="30px" fxLayout="row" fxLayoutAlign="end center">
          <a
            *ngIf="loggedIn"
            (click)="scrollToTop()"
            class="toolbar-text"
            [routerLink]="['/wishlist']">
            <span
              matBadge="15"
              matBadgeColor="warn"
              [matBadge]="wishlistCount > 9 ? '9+' : wishlistCount"
              [matBadgeHidden]="wishlistCount === 0 || wishlistCount < 1"
              matBadgeOverlap="false"
              matBadgePosition="before">
            </span>
            <i class="icofont-ui-love mr-5"></i>
            <span>Wishlist</span>
          </a>
          <a class="toolbar-text" [routerLink]="['/cart']">
            <span
              matBadge="15"
              matBadgeColor="warn"
              [matBadge]="cartItemCount"
              [matBadgeHidden]="cartItemCount === 0 || cartItemCount < 1"
              matBadgeOverlap="false"
              matBadgePosition="before"></span>
            <i class="icofont-cart mr-5"></i>
            <span>Cart</span>
          </a>
          <div
            id="xcom_home_page_sign_in_button"
            class="toolbar-text"
            *ngIf="!loggedIn"
            (click)="onSignin()">
            <i class="icofont-login mr-5"></i>
            Sign In
          </div>
          <div class="toolbar-text" *ngIf="loggedIn" [matMenuTriggerFor]="accountMenu">
            <i class="icofont-ui-user mr-5"></i>
            {{ profileName }}
          </div>
          <mat-menu #accountMenu="matMenu">
            <button
              mat-menu-item
              fxLayout="row"
              fxLayoutAlign="start center"
              [routerLink]="['/orders']">
              <i class="icofont-cart mr-10"></i>
              <span class="nav-menu-text">Orders</span>
            </button>
            <button
              mat-menu-item
              fxLayout="row"
              fxLayoutAlign="start center"
              [routerLink]="['/my-account']">
              <i class="icofont-user mr-10"></i>
              <span class="nav-menu-text">My Account</span>
            </button>
            <button
              id="xcom_home_page_sign_out_button"
              mat-menu-item
              fxLayout="row"
              fxLayoutAlign="start center"
              (click)="onSignout()">
              <i class="icofont-logout mr-10"></i>
              <span class="nav-menu-text">Sign out</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div (click)="onChangeAddress()" *ngIf="addressdata" class="address-container mt-10">
        <i class="icofont-google-map mr-10"></i>
        <span fxLayout="row">
          {{ addressdata.locality ? addressdata.locality : '' }}
          {{ addressdata.city ? addressdata.city : '' }}
          {{ addressdata.landmark ? addressdata.landmark : '' }}
        </span>
      </div>
      <div class="nav-item-section">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/']">Home</a>
          </li>
          <li class="nav-item">
            <a (click)="scrollToTop()" class="nav-link" [routerLink]="['/shop']">Shop</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Mobile view -->

  <div class="header-small-device">
    <div class="toolbar-container sticky-bar">
      <div class="toolbar-top-section">
        <a [routerLink]="['/']">
          <img class="primary-logo" [src]="data.primaryLogoLink" alt="primary-logo" />
        </a>
        <div fxLayoutGap="10px" fxLayout="row">
          <a *ngIf="loggedIn" class="toolbar-text mr-10" [routerLink]="['/wishlist']">
            <span
              matBadge="15"
              matBadgeColor="warn"
              [matBadge]="wishlistCount > 9 ? '9+' : wishlistCount"
              [matBadgeHidden]="wishlistCount === 0 || wishlistCount < 1"
              matBadgeOverlap="false"
              matBadgePosition="before"></span>
            <i class="icofont-ui-love mr-5"></i>
          </a>
          <a class="toolbar-text" [routerLink]="['/cart']">
            <span
              matBadge="15"
              matBadgeColor="warn"
              [matBadge]="cartItemCount"
              [matBadgeHidden]="cartItemCount === 0 || cartItemCount < 1"
              matBadgeOverlap="false"
              matBadgePosition="before"></span>
            <i class="icofont-cart mr-5"></i>
          </a>
          <div class="toolbar-text ml-10" *ngIf="!loggedIn" (click)="onSignin()">
            <i class="icofont-login mr-5"></i>
          </div>
          <a class="toolbar-text" *ngIf="loggedIn" [matMenuTriggerFor]="accountMenu">
            <i class="icofont-ui-user mr-5"></i>
          </a>
          <mat-menu #accountMenu="matMenu">
            <button
              mat-menu-item
              fxLayout="row"
              fxLayoutAlign="start center"
              [routerLink]="['/orders']">
              <i class="icofont-cart mr-10 nav-menu-icon"></i>
              <span class="nav-menu-text">Orders</span>
            </button>
            <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="onSignout()">
              <i class="icofont-logout mr-10 nav-menu-icon"></i>
              <span class="nav-menu-text">Sign out</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div style="width: 100%" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="header-search-bar" fxLayout="row" fxLayoutAlign="space-evenly center">
          <input
            style="border-radius: 2rem 0 0 2rem"
            (keyup.enter)="onSearch()"
            [(ngModel)]="searchInput"
            matInput
            type="text"
            placeholder="Search" />
          <button
            class="close-btn"
            *ngIf="searchInput.length"
            (click)="onSearchClear()"
            mat-icon
            button
            matSuffix>
            <mat-icon>close</mat-icon>
          </button>
          <button
            style="border-radius: 0 2rem 2rem 0; margin: 0px 0px 0px 0px"
            (click)="onSearch()"
            mat-button
            class="search-btn">
            <mat-icon>search</mat-icon>
          </button>
        </div>
        <div class="header-action-wrap header-action-flex header-action-mrg-1">
          <div style="margin-left: 10px" class="same-style header-info">
            <button class="mobile-menu-button-active">
              <i class="ri-menu-2-line" style="color: #333; font-size: 1.5rem"></i>
            </button>
          </div>
        </div>
      </div>
      <div (click)="onChangeAddress()" *ngIf="addressdata" class="address-container mt-10">
        <i class="icofont-google-map mr-10 nav-menu-icon"></i>
        <span fxLayout="row wrap">
          {{ addressdata.locality ? addressdata.locality : '' }}
          {{ addressdata.city ? addressdata.city : '' }}
          {{ addressdata.landmark ? addressdata.landmark : '' }}
        </span>
      </div>
    </div>
  </div>
  <div class="mobile-menu-active clickalbe-sidebar-wrapper">
    <div class="mobile-sidebar-bar">
      <h2>Categories</h2>
      <a id="close-menu" class="sidebar-close">
        <i class="icofont-close-line"></i>
      </a>
    </div>
    <div style="height: 100%; overflow: auto mb-10">
      <ul class="navbar-nav">
        <li (click)="onCloseMenu()" class="nav-item" *ngFor="let item of categoryArray">
          <a
            class="nav-link"
            [ngClass]="{ active: item._id === selectedIndex }"
            (click)="updateQueryParam(item._id, item.subCategoriesInfo[0]._id)">
            {{ item.categoryName.toLowerCase() }}
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="div-height">
    <router-outlet> </router-outlet>
  </div>
  <footer class="footer-container" fxLayout="column" fxLayoutGap="2px">
    <div
      fxLayoutAlign="start stretch"
      fxLayout="row"
      fxLayout.xs="row wrap"
      fxLayout.sm="row wrap"
      fxLayoutGap="2px"
      fxLayoutGap.sm="0px"
      fxLayoutGap.lt-sm="0px">
      <div
        class="inside-footer"
        [style.background-color]="primaryColor"
        fxLayout="column"
        fxFlex="35"
        fxFlex.sm="100"
        fxFlex.xs="100">
        <img [src]="data.footerLogoLink" alt="footer-logo" />
        <b>WAREHOUSE ADDRESS</b>
        <ul class="footer-ul">
          <li style="display: flex; column-gap: 0.25rem">
            <i class="ri-building-3-line"></i>
            {{ data.address }}
          </li>
        </ul>
      </div>
      <div
        class="inside-footer"
        [style.background-color]="primaryColor"
        fxFlex="30"
        fxFlex.sm="100"
        fxFlex.xs="100">
        <b class="footer-heading">{{ data.name }} - THE STORE</b>
        <ul class="footer-ul">
          <li>
            <i class="ri-home-2-line"></i>
            {{ data.storeAddress }}
          </li>
          <li>
            <i class="ri-mail-line"></i>
            <a class="a-tag" href="mailto: {{ data.storeEmail }}">
              {{ data.storeEmail }}
            </a>
          </li>
          <li>
            <i class="ri-map-pin-2-line"></i>
            <a class="a-tag" (click)="onMapInfo(data.long_text, data.lat_text)" target="_blank">
              Location
            </a>
          </li>
        </ul>
      </div>
      <div
        class="inside-footer"
        [style.background-color]="primaryColor"
        fxFlex="35"
        fxFlex.sm="100"
        fxFlex.xs="100">
        <b>CUSTOMER CARE</b>
        <ul class="footer-ul">
          <li *ngIf="data?.contactNumber">
            <i class="ri-phone-line"></i>
            <a class="a-tag" href="tel: +{{ data.contactNumber }}">
              Call Us: +{{ data.contactNumber }}
            </a>
          </li>
          <li *ngIf="data?.contactNumber">
            <i class="ri-whatsapp-line"></i>
            <a class="a-tag" href="https://wa.me/{{ data.contactNumber }}">Message on WhatsApp</a>
          </li>
          <li *ngIf="data?.email">
            <i class="ri-mail-line"></i>
            <a class="a-tag" href="mailto: {{ data.email }}">
              {{ data.email }}
            </a>
          </li>
          <li>
            <i class="ri-questionnaire-line"></i>
            <a class="a-tag">FAQ</a>
          </li>
          <li>
            <i class="ri-git-repository-private-fill"></i>
            <a class="a-tag">Privacy Policy</a>
          </li>
        </ul>
      </div>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      class="footer-end"
      [style.background-color]="secondaryColor">
      <div class="current-year">© {{ currentYear }} {{ data.name }}. All right reserved.</div>
      <div class="powered-by-container" fxLayoutGap="10px">
        <p>
          Powered by
          <a target="_blank" href="https://www.xlayer.in"> xLayer Technologies&#174; <br /> </a>
          Build: {{ buildVersion }}
        </p>
      </div>
    </div>
    <div fxHide.gt-sm class="footer-end-mobile" [style.background-color]="secondaryColor">
      <div class="current-year" fxLayoutAlign="center center">
        © {{ currentYear }} {{ data.name }}. All right reserved.
      </div>
      <a fxLayout="row" fxLayoutAlign="center center" target="_blank" href="https://www.xlayer.in">
        Powered by xLayer Technologies&#174;
      </a>
      <div class="build-version">Build: {{ buildVersion }}</div>
    </div>
  </footer>
</div>
